import PropTypes from "prop-types";
import { AnswerSheetContext } from "./answerSheetContext";
import { useEffect, useState } from "react";
import axios from "axios";

export default function AnswerSheetProvider({ children }) {
  const [fullAnswerSheet, setFullAnswerSheet] = useState([]);
  const [paginationPerpage, setPaginationPerpage] = useState();

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;

  useEffect(() => {
    async function getAnswerSheetList() {
      const url = `${apiUrl}/api/exam/did_exam_list`;

      const getAnswerSheet = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });

      if (getAnswerSheet.status === 200) {
        setFullAnswerSheet(getAnswerSheet.data);
      }
    }

    getAnswerSheetList();
  }, [access_token, apiUrl]);

  useEffect(() => {
    if (fullAnswerSheet.length > 0) {
      setPaginationPerpage(Math.floor(fullAnswerSheet.length / 20));
    }
  }, [fullAnswerSheet]);

  // console.log("🔥 All answer sheet has been rendered: ", fullAnswerSheet);

  return (
    <AnswerSheetContext.Provider
      value={{
        fullAnswerSheet,
        setFullAnswerSheet,
        paginationPerpage,
        setPaginationPerpage,
      }}
    >
      {children}
    </AnswerSheetContext.Provider>
  );
}

AnswerSheetProvider.propTypes = {
  children: PropTypes.any,
};
